module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_iterators.js
// module id = 8
// module chunks = 1